import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-xl border-b-4 border-h-primary-700 w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", { class: "px-5" }, /*#__PURE__*/_toDisplayString("Lista de capítulos"), -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SidebarMaterials = _resolveComponent("SidebarMaterials")!
  const _component_SidebarTrails = _resolveComponent("SidebarTrails")!
  const _component_SidebarChapters = _resolveComponent("SidebarChapters")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_SidebarChapters, { class: "overflow-auto h-[80vh] scroll-style p-5" }, {
      default: _withCtx(() => [
        _createVNode(_component_SidebarTrails, null, {
          default: _withCtx(() => [
            _createVNode(_component_SidebarMaterials)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}